import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { getIconSize } from '../utilities/index.js';
const Car = forwardRef(({ size = 'medium', fill = 'currentColor', ...props }, ref) => {
    const { iconWidth, iconHeight } = getIconSize(size);
    const ariaLabel = props['aria-label'];
    const ariaLabelledby = props['aria-labelledby'];
    let ariaHidden = true;
    if (ariaLabel || ariaLabelledby) {
        ariaHidden = false;
    }
    return (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", ref: ref, fill: fill, width: iconWidth, height: iconHeight, "aria-hidden": ariaHidden, ...props, children: _jsx("path", { fillRule: "evenodd", d: "M3.75 13.906a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5m12.5 0a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5m.024-5.156-1.528-6.875H5.254L3.726 8.75zm-14.468 0L3.533.979A1.25 1.25 0 0 1 4.753 0h10.495a1.25 1.25 0 0 1 1.22.979l1.726 7.771h.556c.69 0 1.25.56 1.25 1.25v7.5h-1.25v1.875c0 .345-.28.625-.625.625h-1.25a.625.625 0 0 1-.625-.625V17.5H3.75v1.875c0 .345-.28.625-.625.625h-1.25a.625.625 0 0 1-.625-.625V17.5H0V10c0-.69.56-1.25 1.25-1.25z" }) }));
});
Car.displayName = 'Car';
Car.__iconComponentType = 'standard';
export default Car;
//# sourceMappingURL=Car.js.map